import { render, staticRenderFns } from "./topTip.vue?vue&type=template&id=2a13442c&scoped=true&"
import script from "./topTip.vue?vue&type=script&lang=js&"
export * from "./topTip.vue?vue&type=script&lang=js&"
import style0 from "./topTip.vue?vue&type=style&index=0&id=2a13442c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a13442c",
  null
  
)

export default component.exports